import React from 'react';
import ajax from './Ajax.svg.js';
import asterisk from './Asterisk.svg.js';
import check from './Check.svg.js';
import circle from './Circle.svg.js';
import closed from './Closed.svg.js';
import diamond from './Diamond.svg.js';
import dollar from './Dollar.svg.js';
import exclamation from './Exclamation.svg.js';
import file from './File.svg.js';
import frown from './Frown.svg.js';
import heart from './Heart.svg.js';
import info from './Info.svg.js';
import minus from './Minus.svg.js';
import neutral from './Neutral.svg.js';
import plus from './Plus.svg.js';
import smile from './Smile.svg.js';
import square from './Square.svg.js';
import star from './Star.svg.js';
import triangle from './Triangle.svg.js';
import upload from './Upload.svg.js';
import warning from './Warning.svg.js';
import x from './X.svg.js';

export const shapeMap = {
  ajax,
  asterisk,
  check,
  circle,
  closed,
  diamond,
  dollar,
  exclamation,
  file,
  frown,
  heart,
  info,
  minus,
  neutral,
  plus,
  smile,
  square,
  star,
  triangle,
  upload,
  warning,
  x,
};

export const shapes = ['smile', 'neutral', 'frown', 'circle'];

export default function Glyph(props) {
  const Shape =
    props.icon && shapeMap[props.icon] ? shapeMap[props.icon] : circle;
  return <Shape {...props} />;
}
